function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import 'researcher/digital-orders/styles/digital-order-payment.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Navigate, Link } from 'react-router-dom';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import Loading from 'researcher/components/Loading';
import useRepeater from 'researcher/hooks/use-repeater';
import { T, useTranslate } from 'shared/helper/translate';
import { DATE_ONLY_FORMAT, dateString } from 'researcher/helpers/date';
import { price } from 'researcher/helpers/price';
import { recordTransaction, recordTrialContractConfirmed, recordPurchaseComplete } from 'researcher/helpers/gtm';
import CurrencySelect from 'researcher/order-form/payment/components/CurrencySelect';
import { updateUserCurrencySelection } from 'researcher/user/actions';
import { getChinaLocalization } from 'shared/account/reducer';
import featureEnabled from 'shared/helper/feature';
import { BANK_TRANSFER, BOLETO, CREDITS } from 'researcher/domain/transaction/payment-method';
import { loadDigitalEditing } from 'researcher/digital-editing/actions';
import { getPurchaseInformation } from '../reducer';
import RubriqPaymentForm from './RubriqPaymentForm';
var RubriqNewCart = function RubriqNewCart(_ref) {
  var _curie$plan$available, _curie$plan$available2, _curie$plans, _curie$plan$available5, _curie$plan$available6, _user$currency, _user$currency2, _payment$receiptCodes;
  var premium = _ref.premium;
  var dispatch = useDispatch();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    digitalPurchase = _useState2[0],
    setDigitalPurchase = _useState2[1];
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useParams = useParams(),
    success = _useParams.success,
    receiptCode = _useParams.receiptCode;
  var chinaLocalization = useSelector(getChinaLocalization);
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    application = _useSelector.application,
    user = _useSelector.user,
    digitalEdit = _useSelector.digitalEdit,
    payment = _useSelector.payment,
    curie = _useSelector.curie;
  var purchaseInformation = useSelector(function (state) {
    return getPurchaseInformation(state, receiptCode);
  });
  var editingPlan = ((_curie$plan$available = curie.plan.availablePlans) === null || _curie$plan$available === void 0 ? void 0 : _curie$plan$available.premium_editing[0]) || [];
  var translationPlan = ((_curie$plan$available2 = curie.plan.availablePlans) === null || _curie$plan$available2 === void 0 ? void 0 : _curie$plan$available2.premium[0]) || [];
  var discountForChina = featureEnabled('china_plans_discount_offers');
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var digitalEditEnabled = !!digitalEdit.hasDigitalEditingPurchase;
  var premiumPlan = (_curie$plans = curie.plans) === null || _curie$plans === void 0 ? void 0 : _curie$plans.premium;
  var daysRemainingBeforePremiumPlanExpires = !premiumPlan || premiumPlan.status === 'expired' ? undefined : Math.ceil((new Date(premiumPlan.endsAt).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
  var isRenewal = !!premiumPlan && daysRemainingBeforePremiumPlanExpires <= 21;
  var _useRepeater = useRepeater({
      fn: function fn() {
        return dispatch(loadDigitalEditing());
      },
      numberOfSecondsBetweenCalls: 10
    }),
    startUpdating = _useRepeater.start,
    stopUpdating = _useRepeater.stop;
  var handleCurrencySubmission = function handleCurrencySubmission(currencyIso) {
    return dispatch(updateUserCurrencySelection(currencyIso));
  };
  useEffect(function () {
    if (success) {
      startUpdating();
    }
    return function () {
      return stopUpdating();
    };
  }, []);
  useEffect(function () {
    if (digitalEdit.enabled) {
      stopUpdating();
    }
  }, [digitalEditEnabled]);
  useEffect(function () {
    if (premium) {
      var _curie$plan$available3;
      setDigitalPurchase((_curie$plan$available3 = curie.plan.availablePlans) === null || _curie$plan$available3 === void 0 ? void 0 : _curie$plan$available3.premium_editing[0]);
    } else {
      var _curie$plan$available4;
      setDigitalPurchase((_curie$plan$available4 = curie.plan.availablePlans) === null || _curie$plan$available4 === void 0 ? void 0 : _curie$plan$available4.premium[0]);
    }
  }, [((_curie$plan$available5 = curie.plan.availablePlans) === null || _curie$plan$available5 === void 0 ? void 0 : _curie$plan$available5.premium) && ((_curie$plan$available6 = curie.plan.availablePlans) === null || _curie$plan$available6 === void 0 ? void 0 : _curie$plan$available6.premium.length)]);

  // useEffect(() => {
  //     if (purchaseInformation) {
  //         recordTransaction(purchaseInformation);
  //     }
  // }, [purchaseInformation !== null]);

  useEffect(function () {
    if (purchaseInformation) {
      recordTransaction(purchaseInformation);
      recordPurchaseComplete({
        transactionId: purchaseInformation.identifier,
        orderId: purchaseInformation.identifier,
        revenue: purchaseInformation.total,
        currency: purchaseInformation.currency,
        productName: '',
        planTerm: purchaseInformation.planTerm,
        paymentMode: ''
      });
    }
  }, [purchaseInformation !== null]);
  if (!paddleBillingForChina) {
    if (!digitalPurchase) {
      return /*#__PURE__*/React.createElement(Loading, null);
    }
  }
  if (!chinaLocalization || paddleBillingForChina) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/rubriq/plan/subscribe",
      replace: true
    });
  }
  if (!application.allowsDigitalEditing) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/rubriq",
      replace: true
    });
  }
  if (digitalEditEnabled && success && purchaseInformation) {
    return /*#__PURE__*/React.createElement(Navigate, {
      to: "/rubriq",
      replace: true
    });
  }
  var today = new Date();
  var formatDate = function formatDate(date) {
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    return "".concat(day, "/").concat(month, "/").concat(year);
  };
  var renewalDate = new Date();
  renewalDate.setFullYear(today.getFullYear() + 1);
  var nextRenewalDate = renewalDate;
  var cardClassEditing = premium ? 'border-success rubriq-selected' : 'rubriq-un-selected';
  var cardClassTranslation = !premium ? 'border-success rubriq-selected' : 'rubriq-un-selected';
  var discountedPrice = (digitalPurchase === null || digitalPurchase === void 0 ? void 0 : digitalPurchase.price) * (1 - (digitalPurchase === null || digitalPurchase === void 0 ? void 0 : digitalPurchase.discountPercent) / 100);
  var enableDiscount = discountForChina && (digitalPurchase === null || digitalPurchase === void 0 ? void 0 : digitalPurchase.discountPercent) > 0 && (digitalPurchase === null || digitalPurchase === void 0 ? void 0 : digitalPurchase.discountPercent) < 100;
  var handlePaymentCLick = function handlePaymentCLick() {
    recordTrialContractConfirmed({
      productName: premium ? 'Rubriq Premium' : 'Rubriq Premium with Translation',
      finalAmount: price(user.currency, discountedPrice, true, true)
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !success && /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto col-12 bg-white rubriq-specific-font g-padding"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    className: "h3 fw-semibold text-dark mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.purchase-summary-header"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row rubriq-purchase-summary-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8 col-md-7 border-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h5 fw-semibold mb-0 text-dark"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.trial-price",
    params: {
      price: enableDiscount ? price(user.currency, discountedPrice, true, true) : price(user.currency, digitalPurchase === null || digitalPurchase === void 0 ? void 0 : digitalPurchase.price, true, true)
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-0 m-0 mt-3 rubriq-plan-feature-list"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "one year premium access"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-3"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/rubriq/subscribe/cart/translation",
    className: "text-decoration-none",
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card border-2 ".concat(cardClassTranslation, " position-relative bg-transparent"),
    style: {
      cursor: 'pointer',
      transition: 'all 0.2s'
    },
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body p-3 d-flex flex-column justify-content-between h-100"
  }, true && /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "badge rubriq-badge px-3 py-2 rounded-pill"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.most-popular"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center flex-grow-1 flex-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-between w-100 mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-circle border border-2 d-flex align-items-center justify-content-center ".concat(!premium ? 'border-success rubriq-bg' : 'border-secondary'),
    style: {
      width: '20px',
      height: '20px'
    }
  }, !premium && /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-circle",
    style: {
      width: '8px',
      height: '8px'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "fw-medium text-dark"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.rubriq-premium-with-translation"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-baseline w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: " small text-muted"
  }, /*#__PURE__*/React.createElement(T, {
    source: "premium access till"
  }), " ", formatDate(nextRenewalDate)), /*#__PURE__*/React.createElement("div", {
    className: "h5 fw-bold text-dark mb-0"
  }, enableDiscount ? price(user.currency, (translationPlan === null || translationPlan === void 0 ? void 0 : translationPlan.price) * (1 - (translationPlan === null || translationPlan === void 0 ? void 0 : translationPlan.discountPercent) / 100), true, true) : price(user.currency, translationPlan.price, true, true), ' ', ((_user$currency = user.currency) === null || _user$currency === void 0 ? void 0 : _user$currency.isoCode) || 'USD', " /", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, {
    source: "One-time"
  })))))))), /*#__PURE__*/React.createElement(Link, {
    to: "/rubriq/subscribe/cart/editing",
    className: "text-decoration-none",
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "card border-2 ".concat(cardClassEditing, " position-relative bg-transparent"),
    style: {
      cursor: 'pointer',
      transition: 'all 0.2s'
    }
    // onClick={() => setSelectedPlan(plan)}
    ,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body p-3 d-flex flex-column justify-content-between h-100"
  }, false && /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "badge rubriq-badge px-3 py-2 rounded-pill"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.most-popular"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center flex-grow-1 flex-column"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-between w-100 mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-circle border border-2 d-flex align-items-center justify-content-center ".concat(premium ? 'border-success rubriq-bg' : 'border-secondary'),
    style: {
      width: '20px',
      height: '20px'
    }
  }, premium && /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-circle",
    style: {
      width: '8px',
      height: '8px'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "fw-medium text-dark"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.curie-premium"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-baseline w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: " small text-muted"
  }, /*#__PURE__*/React.createElement(T, {
    source: "premium access till"
  }), " ", formatDate(nextRenewalDate)), /*#__PURE__*/React.createElement("div", {
    className: "h5 fw-bold text-dark mb-0"
  }, enableDiscount ? price(user.currency, (editingPlan === null || editingPlan === void 0 ? void 0 : editingPlan.price) * (1 - (editingPlan === null || editingPlan === void 0 ? void 0 : editingPlan.discountPercent) / 100), true, true) : price(user.currency, editingPlan.price, true, true), ' ', ((_user$currency2 = user.currency) === null || _user$currency2 === void 0 ? void 0 : _user$currency2.isoCode) || 'USD', " /", /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, {
    source: "One-time"
  }))))))))), /*#__PURE__*/React.createElement("div", {
    className: "row mb-5 mt-5 ms-1"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "fw-bold mt-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.invoicing"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8 col-md-10"
  }, /*#__PURE__*/React.createElement(T.md, {
    className: "fapiao-notice",
    source: "fapiao-after-payment-notice",
    linkRenderer: function linkRenderer(_ref2) {
      var href = _ref2.href,
        children = _ref2.children;
      return /*#__PURE__*/React.createElement("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer"
      }, children);
    }
  }))), !success && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 ms-3"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "fw-bold mt-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.select-payment-method"
  })))), /*#__PURE__*/React.createElement("div", null, !user.currencyIso ? /*#__PURE__*/React.createElement(CurrencySelect, {
    handleCurrencySubmission: handleCurrencySubmission
  }) : null, /*#__PURE__*/React.createElement(RubriqPaymentForm, {
    additionalData: {
      availableDigitalPurchaseIdentity: digitalPurchase.identity
    },
    currency: user.currency,
    convertNumberOfInstallments: user.currency !== 'USD',
    excludePaymentMethods: [BANK_TRANSFER, BOLETO, CREDITS],
    paymentsEndpoint: "/api/digital-edit/payment",
    bankTransferDisabled: true,
    receiptCode: (_payment$receiptCodes = payment.receiptCodes) === null || _payment$receiptCodes === void 0 ? void 0 : _payment$receiptCodes.digital,
    total: enableDiscount ? discountedPrice : digitalPurchase === null || digitalPurchase === void 0 ? void 0 : digitalPurchase.price,
    submitDisabled: !user.currencyIso
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Pay now'),
    type: "submit",
    disabled: payment.status.saving || payment.status.loading || !user.currencyIso,
    onClick: handlePaymentCLick,
    id: "keep_payment_btn_cn",
    className: "btn btn-primary btn-squared-large payment-button float-end me-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.continue-to-payment"
  })), payment.status.saving ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null))))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4 col-md-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card bg-transparent border-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body p-4"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "h5 fw-medium text-dark mb-4"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.your-order-summary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fw-semibold text-dark"
  }, premium ? /*#__PURE__*/React.createElement(T, {
    source: "curie.curie-premium"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "rubriq.rubriq-premium-with-translation"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold text-dark"
  }, /*#__PURE__*/React.createElement(T, {
    source: "One-time payment"
  }), ' ')), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-circle d-flex align-items-center justify-content-center flex-shrink-0",
    style: {
      width: '24px',
      height: '24px',
      marginTop: '2px',
      backgroundColor: '#D3A834'
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "fw-medium text-dark"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.today"
  }), " ", formatDate(today)), /*#__PURE__*/React.createElement("div", {
    className: "small text-muted"
  }, /*#__PURE__*/React.createElement(T, {
    source: "1 year premium access"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "alert alert-light border"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-circle-info",
    className: "text-muted me-2 mt-1"
  }), /*#__PURE__*/React.createElement("p", {
    className: "small text-muted mb-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.translation-disclaimer"
  })))))))))), success && /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto digital-edit-payment rubriq-cart g-padding"
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: "Digital Editing"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "py-3 fw-bold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.checkout"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }, success && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning rounded-3"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-2",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }), /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "curie.purchase-plan-loading-notice"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "fw-bold mt-0 mb-5 mt-4"
  }, /*#__PURE__*/React.createElement(T, {
    inline: true,
    source: "curie.cart-summary"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8 col-md-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-4 border p-3"
  }, /*#__PURE__*/React.createElement("p", {
    className: "m-0 fw-bold"
  }, premium ? /*#__PURE__*/React.createElement(T, {
    source: "curie.premium"
  }) : /*#__PURE__*/React.createElement(T, {
    source: "rubriq.rubriq-premium-with-translation"
  })), /*#__PURE__*/React.createElement("p", {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.plan-billing-period-yearly"
  }), ', ', " ", /*#__PURE__*/React.createElement(T, {
    source: "curie.expiring"
  }), ' ', dateString(t, moment(premiumPlan === null || premiumPlan === void 0 ? void 0 : premiumPlan.startsAt).add(1, 'year'), DATE_ONLY_FORMAT)), /*#__PURE__*/React.createElement("p", {
    className: "m-0"
  }, enableDiscount ? price(user.currency, discountedPrice, true, true) : price(user.currency, digitalPurchase === null || digitalPurchase === void 0 ? void 0 : digitalPurchase.price, true, true))))), isRenewal && /*#__PURE__*/React.createElement("div", {
    className: "row mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "fw-bold mt-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.cart-renewal-details-title"
  })), /*#__PURE__*/React.createElement("p", {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.cart-renewal-details-content",
    params: {
      planRemainingDays: daysRemainingBeforePremiumPlanExpires
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "fw-bold mt-0 mb-2"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.invoicing"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "row mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8 col-md-10"
  }, /*#__PURE__*/React.createElement(T.md, {
    className: "fapiao-notice",
    source: "fapiao-after-payment-notice",
    linkRenderer: function linkRenderer(_ref3) {
      var href = _ref3.href,
        children = _ref3.children;
      return /*#__PURE__*/React.createElement("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer"
      }, children);
    }
  })))));
};
export default RubriqNewCart;